import { render, staticRenderFns } from "./ProductOfCart.vue?vue&type=template&id=1b1a2d27&scoped=true&"
import script from "./ProductOfCart.vue?vue&type=script&lang=js&"
export * from "./ProductOfCart.vue?vue&type=script&lang=js&"
import style0 from "./ProductOfCart.vue?vue&type=style&index=0&id=1b1a2d27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1a2d27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1b1a2d27', component.options)
    } else {
      api.reload('1b1a2d27', component.options)
    }
    module.hot.accept("./ProductOfCart.vue?vue&type=template&id=1b1a2d27&scoped=true&", function () {
      api.rerender('1b1a2d27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cart/ProductOfCart.vue"
export default component.exports